"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { checkFiles } from "@/lib/files";
import { clearHandedOffFiles, peekHandedOffFiles } from "@/lib/handoff";
import type { Tool } from "@/lib/tools";

/** A tool page's original files, starting with any handed over from the home
 *  page or another tool. `notices` explains files that couldn't be taken. */
export function useToolFiles(tool) {
  const $ = _c(9);
  let t0;
  if ($[0] !== tool.accepts || $[1] !== tool.acceptsLabel || $[2] !== tool.maxBytes || $[3] !== tool.maxFiles) {
    t0 = () => checkFiles(peekHandedOffFiles(), {
      accepts: tool.accepts,
      maxFiles: tool.maxFiles,
      maxBytes: tool.maxBytes,
      acceptsLabel: tool.acceptsLabel
    });
    $[0] = tool.accepts;
    $[1] = tool.acceptsLabel;
    $[2] = tool.maxBytes;
    $[3] = tool.maxFiles;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const [initial] = useState(t0);
  const [files, setFiles] = useState(initial.accepted);
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[6] !== files || $[7] !== initial.problems) {
    t2 = {
      files,
      setFiles,
      notices: initial.problems
    };
    $[6] = files;
    $[7] = initial.problems;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp() {
  return clearHandedOffFiles();
}